document.querySelectorAll('.dv-play-btn').forEach(function (btn) {
  var video = btn.parentElement && btn.parentElement.querySelector('video');
  if (!video) return;

  btn.addEventListener('click', function () {
    if (video.paused) {
      video.play();
      btn.classList.remove('is-paused');
      btn.setAttribute('aria-label', 'Pause video');
    } else {
      video.pause();
      btn.classList.add('is-paused');
      btn.setAttribute('aria-label', 'Play video');
    }
  });
});
